<template>
<modal name="adtop-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="permissionType == 2">
    <p>
      <img src="/static/renew_img/yagish_baite_20220110_title.png" style="width: 70%;"  alt="詳しく見る" >
    </p>
    <p>
      <a href="https://bit.ly/33ndakU" target="_blank"><img src="/static/renew_img/yagish_baite_20220111_contents.png" style="width: 100%;"  alt="詳しく見る" ></a>
    </p>
  </div>
  <div class="setting" v-if="permissionType == 3">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">東京、神奈川、千葉、埼玉の方 限定！</p>
      <p style="font-size: 120%;">今作成した職務経歴書をもとに<br>プロが好条件の看護師の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/cocorowa_yagish_logo.png" style="width:100%" >
        </p>
      </div>
      <p style="font-size: 120%;">ご同意いただいた方には追ってメールが<br>届きますので、ご確認お願いいたします！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:		scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">同意して無料相談を希望</el-checkbox>
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-cocorowa-consult');">同意する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・無料相談をご希望いただいた方には、順次ご連絡させていただきます。<br/>少々お待ちいただきますよう予めご了承ください。
      </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">同意しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 100%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 100%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
    </div>
  </div>
  <div class="setting" v-if="permissionType == 4">
    <div class="setting-item" style="text-align:center;">
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/agree/logo.svg" style="width:50%" >
        </p>
      </div>
      <p style="font-size: 120%;">株式会社Yagishで社員を募集しています！</p><br>
      <p style="font-size: 140%;">WEBデザイナー</p>
      <p style="font-size: 100%;text-align:left;padding-left:10px">急成長中のYagishでWebデザイナー、UI／UXデザイナーを募集中！</p>
      <p style="font-size: 120%;text-align:left;"><img src="/static/renew_img/check_icon.png" style="width:40px;vertical-align: middle;" >募集要件</p>
      <p style="font-size: 90%;text-align:left;padding-left:30px">Webデザイナー、UI／UXデザイナーの経験が3年以上の方</p><br>
      <p style="font-size: 120%;text-align:left;"><img src="/static/renew_img/check_icon.png" style="width:40px;vertical-align: middle;" >給与</p>
      <p style="font-size: 90%;text-align:left;padding-left:30px">スキルに応じてお支払い</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/bnr/hero2_designer_20220916_001.png" style="width:80%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:		scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">同意する</el-checkbox>
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-yagish-saiyo');">応募する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・こちらにご応募していただいた方には、書類選考後、面接に進む場合に限り、ご連絡させていただきます。<br/>少々お待ちいただきますよう予めご了承ください。
      </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">応募しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 100%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 100%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
    </div>
  </div>
  <div class="setting" v-if="permissionType == 5">
    <div class="setting-item" style="text-align:center;">
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/agree/logo.svg" style="width:50%" >
        </p>
      </div>
      <p style="font-size: 120%;">株式会社Yagishで社員を募集しています！</p><br>
      <p style="font-size: 140%;">マーケティング</p>
      <p style="font-size: 100%;text-align:left;padding-left:10px">急成長中のYagishでマーケターを募集中！</p>
      <p style="font-size: 120%;text-align:left;"><img src="/static/renew_img/check_icon.png" style="width:40px;vertical-align: middle;" >募集要件</p>
      <p style="font-size: 90%;text-align:left;padding-left:30px">マーケティングの経験が3年以上の方</p><br>
      <p style="font-size: 120%;text-align:left;"><img src="/static/renew_img/check_icon.png" style="width:40px;vertical-align: middle;" >給与</p>
      <p style="font-size: 90%;text-align:left;padding-left:30px">スキルに応じてお支払い</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/bnr/hero2_marketing_20220916_001.png" style="width:80%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:		scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">同意する</el-checkbox>
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-yagish-saiyo');">応募する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・こちらにご応募していただいた方には、書類選考後、面接に進む場合に限り、ご連絡させていただきます。<br/>少々お待ちいただきますよう予めご了承ください。
      </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">応募しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 100%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 100%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
    </div>
  </div>
  <div class="setting" v-if="permissionType == 6">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">転職活動の準備ができているか<br>チェックリストを確認してね！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://special.yagish.jp/akapen_jinji/index.html', '_blank');" ><span>落ちる人の書き方を確認</span></button>
        <!-- https://bit.ly/3DrwnQC -->
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px" >効果的な仕事探しをしていますか？<br/>
          作成した履歴書を送って転職先に関する<br/>
          無料相談をしましょう
        </p>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>について
          <br/>
          ㈱アド・トップの転職支援サービス<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報の取り扱い</a>について
        </p>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:		scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">同意して無料相談を希望</el-checkbox>
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false" 
          style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
          @click="$eventHub.$emit('send-adtop-consult');">同意する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success" style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・無料相談は順次にご連絡をさせて頂きます。<br/>少々お時間いただきますので予めご了承ください。
      </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">同意しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://special.yagish.jp/akapen_jinji/index.html', '_blank');" ><span>落ちる人の書き方を確認</span></button>
        <!-- https://bit.ly/3DrwnQC -->
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://special.yagish.jp/taishoku/index.html', '_blank');" ><span>心配な人は詳細を確認</span></button>
      </div>
    </div>
  </div>
  <div class="setting" v-if="permissionType == 7">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">転職活動の準備ができているか<br>チェックリストを確認してね！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://special.yagish.jp/akapen_jinji/index.html', '_blank');" ><span>落ちる人の書き方を確認</span></button>
        <!-- https://bit.ly/3DrwnQC -->
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://special.yagish.jp/taishoku/index.html', '_blank');" ><span>心配な人は詳細を確認</span></button>
      </div>
    </div>
  </div>

</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 2,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false,
      inputEmail:''
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openDialog: function (id, html, email) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = email
      this.$modal.show('adtop-dialog')
      this.clearLocalStorageConfirmVisible = false
      if (id == "nurse_shokumukeirekisho") {
        this.permissionType = 6
      } else if (id == "webdesign_shokumukeirekisho") {
        this.permissionType = 4
        this.closeDialog()
      } else if (id == "marketing_shokumukeirekisho") {
        this.permissionType = 5
        this.closeDialog()
      } else if (id == "sales_shokumukeirekisho"
      || id == "service_shokumukeirekisho"
      || id == "plan_shokumukeirekisho") {
        this.permissionType = 6
      } else {
        this.permissionType = 7
      }
    },
    closeDialog: function () {
      this.$modal.hide('adtop-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendAdtopScout: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('format_id', this.formatId)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '1')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
        })
    },
    sendCocorowaConsult: async function () {
      console.log(this.username);
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.cocorowaPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendYagishSaiyo: async function () {
      console.log(this.username);
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.yagishPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `応募完了いたしました。`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-cocorowa-consult', this.sendCocorowaConsult)
    this.$eventHub.$on('send-yagish-saiyo', this.sendYagishSaiyo)
    this.$eventHub.$on('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$on('send-adtop-scout', this.sendAdtopScout)
    this.$eventHub.$on('open-adtop-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-cocorowa-consult', this.sendCocorowaConsult)
    this.$eventHub.$off('send-yagish-saiyo', this.sendYagishSaiyo)
    this.$eventHub.$off('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$off('send-adtop-scout', this.sendAdtopScout)
    this.$eventHub.$off('open-adtop-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
